<template>
  <div class="sem-qa">
    <template>
      <Banner
        :showForm="!showScrollForm"
        :video="banner.video"
        @msg="handleShowMsg"
        :landingPageName="landingPageName"
        @setShowSuccessDialog="setShowSuccessDialog"
      />
      <!-- 电子合同常见问题解答 -->
      <div class="electronic-contract-faq">
        <SectionCard :isPcFlag="true" title="电子合同常见问题解答">
          <div class="faq-content">
            <div class="left">
              <img class="faq-img" v-for="(item, index) in faqData" :key="item.key" :src="item.imgSrc" v-show="activeIndex === index" />
            </div>
            <div class="right">
              <div class="right-content">
                <div class="item-content" v-for="(v, i) in faqData" :key="v.key">
                  <div class="title" :class="{ activeClass: activeIndex === i }" @click="activeIndex = i">
                    <img class="point-to" v-if="activeIndex === i" src="@/assets/images/sem-qa/faq-open.png" alt="" />
                    <img class="point-to" v-else src="@/assets/images/sem-qa/faq-close.png" alt="" />
                    {{ v.title }}
                  </div>
                  <div class="content" v-show="activeIndex === i">
                    <div class="desc" v-for="(val, ind) in v.desc" :key="ind">{{ val }}</div>
                    <div class="more" @click="OnlineConsultationClick">咨询更多 ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="btns-box">
            <div class="btns">
              <div class="mfsy" @click="showDialog">免费试用</div>
              <div class="zxzx" @click="OnlineConsultationClick">在线咨询</div>
            </div>
          </div>
        </SectionCard>
      </div>
      <!-- 灵活产品与能力 -->
      <ProductPower class="product-power" @showDialog="showDialog" :title="productPower.title" :powerList="productPower.powerList" />
      <!-- 无需邮寄，1分钟完成线上签署 -->
      <div class="flow-path">
        <SectionCard :isPcFlag="true" title="无需邮寄，1分钟完成线上签署" :bgImg="flowPathBg">
          <div class="path-content">
            <div class="content">
              <div class="path-left">
                <div class="one-line">
                  <div class="item" v-for="item in flowPathOneLine" :key="item.key">
                    <div class="item-content">
                      <img :src="item.imgSrc" alt="" />
                      <p>{{ item.text }}</p>
                    </div>
                    <img class="one-line-arrow" v-if="item.key !== 4" src="@/assets/images/sem-saas/flow-arrow.png" alt="" />
                  </div>
                </div>
                <div class="two-line">
                  <img class="two-line-arrow" src="@/assets/images/sem-saas/flow-arrow.png" alt="" />
                </div>
                <div class="three-line">
                  <div class="item" v-for="item in flowPathTwoLine" :key="item.key">
                    <div class="item-content">
                      <img :src="item.imgSrc" alt="" />
                      <p>{{ item.text }}</p>
                    </div>
                    <img class="three-line-arrow" v-if="item.key !== 4" src="@/assets/images/sem-saas/flow-arrow.png" alt="" />
                  </div>
                </div>
              </div>
              <div class="path-right">
                <img class="qr-img" :src="qrCodeUrl" alt="" />
                <p class="qr-desc">扫码免费领取5份试用</p>
              </div>
            </div>
          </div>
        </SectionCard>
      </div>
      <!-- 行业实践解决方案 -->
      <SolutionList class="solution-saas" :title="solutions.title" :solutionList="solutions.list" @showDialog="showDialog" />
      <!-- e签宝核心优势 -->
      <CoreSuperiority
        class="core-superiority"
        :title="superiority.title"
        :numberList="superiority.numberList"
        :textList="superiority.textList"
      />
      <!-- 客户成功案例 -->
      <OrgList class="org-list" :title="orgList.title" :orgTypeList="orgList.orgTypeList" :imgs="orgList.imgs" />
      <NumberInfo
        @showDialog="showDialog"
        :title="numberInfo.title"
        :numberList="numberInfo.numberList"
        :qrImgUrl="numberInfo.qrImgUrl"
      ></NumberInfo>
    </template>
    <!-- 公共模块 -->
    <WeilingSuccessDialog :wlCode="true" v-if="showSuccessDialog" @closeform="showSuccessDialog = false" />
    <Message :type="message.type" :title="message.title" :content="message.content" :show.sync="message.show" />
    <UseDialog ref="dialog" :wlCode="true" />
    <!-- 底部小象留资 -->
    <ScrollForm
      :show="showScrollForm"
      @msg="handleShowMsg"
      @setShowSuccessDialog="setShowSuccessDialog"
      :landingPageName="landingPageName"
    />
    <!-- 底部备案信息 -->
    <Footer />
    <!-- 右侧客服信息 -->
    <Contact :landingPageName="landingPageName" :source="source" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import dataList from './dataList'
import qiyuMixin from '@/mixins/form/qiyu.js'
export default {
  name: 'semQa',
  mixins: [qiyuMixin],
  components: {
    Banner: () => import('@/views/extension/components/pc/Banner.vue'),
    Message: () => import('@/views/extension/components/pc/Message.vue'),
    ProductPower: () => import('@/views/extension/components/pc/ProductPower.vue'),
    UseDialog: () => import('@/components/UseDialog.vue'),
    SectionCard: () => import('@/components/basics/SectionCard.vue'),
    SolutionList: () => import('@/views/extension/components/pc/SolutionList.vue'),
    CoreSuperiority: () => import('@/views/extension/components/pc/CoreSuperiority.vue'),
    OrgList: () => import('@/views/extension/components/pc/OrgList.vue'),
    NumberInfo: () => import('@/views/extension/components/pc/NumberInfo.vue'),
    ScrollForm: () => import('@/views/extension/components/pc/ScrollForm.vue'),
    Footer: () => import('@/views/extension/components/pc/Footer.vue'),
    WeilingSuccessDialog: () => import('@/components/saasApiSuccessForm.vue'),
    Contact: () => import('@/components/Contact.vue'),
  },
  computed: {
    ...mapState({
      qrCodeUrl: state => state.user.wlQrcode,
    }),
  },
  data() {
    return {
      activeIndex: 0,
      showScrollForm: false,
      showSuccessDialog: false,
      // 落地页名字'e签宝宣传'，因为以上的组件会被多次复用，为了服务商收集数据的时候能够更准确，用这个名字去判断是否需要向服务商发送数据
      landingPageName: 'esignPropagate',
      banner: {
        video: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanre/banner.mp4',
      },
      message: {
        type: '',
        title: '',
        content: '',
        show: false,
      },
      source: 'yinzhangright', // 咨询来源：客服
      flowPathBg: require('@/assets/images/sem-saas/flow-path.png'),
      productPower: dataList.productPower,
      flowPathOneLine: dataList.flowPathOneLine,
      flowPathTwoLine: dataList.flowPathTwoLine,
      solutions: dataList.solutions,
      superiority: dataList.superiority,
      orgList: dataList.orgList,
      numberInfo: dataList.numberInfo,
      faqData: dataList.faqData,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollHandle, true)
  },
  methods: {
    showDialog() {
      this.$refs.dialog.showDialog()
    },
    OnlineConsultationClick() {
      this.handleCustomerClick({ templateId: '6651711' })
    },
    handleShowMsg({ type, title, content }) {
      this.message.type = type
      this.message.title = title
      this.message.content = content
      this.message.show = true
    },
    setShowSuccessDialog(v) {
      this.showSuccessDialog = v
    },
    scrollHandle() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
      this.showScrollForm = scrollTop >= 2280
      this.$refs.newHeader && this.$refs.newHeader.scrollHandle()
    },
  },
}
</script>

<style lang="less" scoped>
@import './style.less';
</style>
